import ProductDescriptionStore from '../store/ProductDescriptionStore';

import { fetchFromJson } from './fetchFromJson';

const db = new ProductDescriptionStore('productsDescriptionDb');

const updateCache = 'productsDescription_updateCache';
const getUpdateCache = (data) => data.descriptions;
const toast = 'Products Descriptions Updated';
const entityName = 'productDescriptions';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
